import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MicrophoneOffIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#clip0_12712_346608)",
                            children: _jsx("path", {
                                d: "M.293.293a1 1 0 011.414 0l22 22a1 1 0 01-1.414 1.414l-6.635-6.635a7.095 7.095 0 01-2.658.867V21h3a1 1 0 110 2H8a1 1 0 110-2h3v-3.06c-3.165-.392-5.47-2.644-5.92-5.799a1 1 0 011.98-.282C7.41 14.32 9.291 16 12 16c.8 0 1.53-.147 2.168-.418l-.816-.816A4 4 0 018 11V9.414L.293 1.707a1 1 0 010-1.414zM11.53 12.945l-1.474-1.475c.175.727.747 1.3 1.474 1.474zM14 9.793V5a2 2 0 10-4 0v.793L8.143 3.936A4.002 4.002 0 0116 5v6c0 .248-.023.491-.066.727L14 9.793zm4.92 2.348a7.194 7.194 0 01-.579 1.992l-1.553-1.553c.066-.232.117-.472.152-.721a1 1 0 011.98.282z",
                                fillRule: "evenodd",
                                clipRule: "evenodd"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "clip0_12712_346608",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
MicrophoneOffIcon.isCarinaIcon = true;
export default MicrophoneOffIcon;
